import type { HTMLAttributes, PropsWithChildren } from 'react';

export type LinkProps = {
  href: string | undefined;
  className?: string;
} & HTMLAttributes<HTMLAnchorElement>;

export function Link({
  href,
  className,
  children,
  ...attributes
}: PropsWithChildren<LinkProps>) {
  return (
    <a
      href={href}
      className={`flex flex-row justify-start items-center ${className}`}
      {...attributes}
    >
      {children}
    </a>
  );
}
